import { Component, inject, Signal } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslatePipe } from '@ngx-translate/core';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';

import { Box } from '../../../../../core/models';
import { ImageComponent } from '../../../shared/components';
import { ApplicationFileType } from '../../../../../core/enums';
import { DialogComponent } from '../../../../../core/models/dialog.data';

@Component({
  selector: 'dbx-add-box-confirmation-dialog',
  templateUrl: './add-box-confirmation-dialog.component.html',
  styleUrl: './add-box-confirmation-dialog.component.scss',
  imports: [
    TranslatePipe,
    MatButton,
    ImageComponent,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatProgressSpinnerModule,
  ],
  standalone: true,
})
export class AddBoxConfirmationDialogComponent extends DialogComponent<
  AddBoxConfirmationDialogComponent,
  {
    box: Box;
    saving: Signal<boolean>;
  },
  boolean
> {
  private readonly dialogData = inject<{ box: Box; saving: Signal<boolean> }>(MAT_DIALOG_DATA);

  box = this.dialogData.box;
  readonly saving = this.dialogData.saving;
  readonly ApplicationFileType = ApplicationFileType;

  register(): void {
    if (!this.saving()) {
      this.close(true);
    }
  }
}
